import React from 'react';
import { HeaderLogo } from '../components/HeaderLogo';
import UserProfile from '../widgets/UserProfile';
import { TopNav } from './TopNav';


  interface PageHeaderProps {
    suppressLoginButtons?: boolean
  }
const PageHeader = (props: React.HTMLAttributes<HTMLElement> & PageHeaderProps) => (

  <div className="uk-background-default uk-grid inline">
    <div>
      <div className="uk-align-left uk-card">
        <h2 className="uk-margin-remove-bottom uk-padding-small">
          <HeaderLogo />
          <span className="uk-margin-left">
            Flax&nbsp;Serial Tracking
        </span>
        </h2>
      </div>
    </div>
    <div className="uk-width-expand">
      <div className="uk-align-left uk-card">
      </div>
    </div>
    <div>
      {!props.suppressLoginButtons && 
      <div className="uk-card uk-margin-top uk-padding-small uk-align-right uk-valign-center">
        <TopNav />
        <UserProfile />
      </div>
      }
    </div>
  </div>
);

export default PageHeader;
